import "./Home.css"
import { useState, useEffect, useContext, useRef } from "react";
import useInactivityTimeout from "../../Utilities/useInactivityTimeout"
import { Button, Card, Footer } from '@nxtvid/component-library';
import { UserQueryContext } from "../../Contexts/UserQueryContext";
import handleVideographerSignUpButtonClick from "../../Utilities/handleVideographerSignUpButtonClick";
import { UserContext } from "../../Contexts/UserContext";

const Home = () =>{
    
    const searchButtonIcon = require('../../Images/SearchButton.png')
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [previousImageIndex, setPreviousImageIndex] = useState(null);
    const [projectCategories, setProjectCategories] = useState([['Event', require('../../Images/EventImage.webp')], ['Product', require('../../Images/ProductImage.jpeg')], ['Food & Beverage', require('../../Images/FoodAndBeverageImage.jpeg')]])
    const [featuredListings, setFeaturedListings] = useState(['672d55c6618433f7285650ae', '672d45eb99cfb71cf26de3cf', '672d6747def2d5c3f4036ef2'])
    const [featuredListingInfo, setFeaturedListingInfo] = useState([])
    const [featuredListingVideos, setFeaturedListingVideos] = useState([])
    const [isLoaded, setIsLoaded] = useState(false)
    const [featuredListingLogos, setFeaturedListingLogos] = useState([])
    const [projectCategoryVideos, setProjectCategoryVideos] = useState({product: null, foodAndBeverage: null, event: null})
    const { userQuery, setUserQuery } = useContext(UserQueryContext);
    const man_searching_directory = require('../../Images/man-searching-nxtvid-directory.webp')
    const nxtvid_logo = require('../../Images/Logo.png')
    const homePageImages = [require('../../Images/homepage-images/Unsplash1.webp'), require('../../Images/homepage-images/Unsplash2.webp'), require('../../Images/homepage-images/Unsplash3.webp'), require('../../Images/homepage-images/Unsplash4.webp'), require('../../Images/homepage-images/Unsplash5.webp')]
    const arrowImg = require('../../Images/back-icon.png')
    const {userInfo, setUserInfo} = useContext(UserContext);
    const howItWorksRef = useRef(null);
    useInactivityTimeout(21600000, 'cooppStoryboardGenerator_AuthToken');

    const handleScrollToHowItWorks = () => {
      const offset = 60;
      const topPosition = howItWorksRef.current.offsetTop - offset;
      window.scrollTo({ top: topPosition, behavior: 'smooth' });
    };

    useEffect(() => {
      const handleScroll = () => {
        const searchBar = document.querySelector('.MainSearchBar');
        const stickyClass = 'sticky';
        const scrollPosition = window.scrollY;
  
        if (scrollPosition > window.innerHeight * 0.6) { // Adjust this value as needed
          searchBar.classList?.add(stickyClass);
        } else {
          searchBar.classList?.remove(stickyClass);
        }
      };
  
      window.addEventListener('scroll', handleScroll);
  
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);

    useEffect(() => {
      const fetchData = async () => {
        if (!isLoaded) {
          await getFeaturedListingInfo();
        }
      };
    
      fetchData();
    }, [featuredListings, isLoaded]);

    useEffect(() => {
      let isMounted = true;
      if(isLoaded){
        return undefined
      }
      const fetchAllVideos = async () => {
        const tempFeaturedListingVideos = await Promise.all(
          featuredListingInfo.map(async (listing) => {
            let directorReel = identifyDirectorsReel(listing);
         
            const url = await fetchSignedUrl(directorReel);
       
            return url;
          })
        );
        const tempFeaturedListingLogos = await Promise.all(
          featuredListingInfo.map(async (listing) => {
           
            const filePath = listing.companyLogo.split('/').pop();
       
            const url = await fetchSignedUrlLogo(filePath);
            return url;
          })
        );
        const tempProjectCategoryVideos = identifyProjectCategoryVideos(featuredListingInfo);
        let tempProjectCategoryVideosUrls = {}
        await Promise.all(
          Object.keys(tempProjectCategoryVideos).map(async (key) => {
            
            if (key === null) {
              return null;
            }
            const url = await fetchSignedUrl(tempProjectCategoryVideos[key]);
            tempProjectCategoryVideos[key] = url;
            setProjectCategoryVideos(tempProjectCategoryVideos);
            tempProjectCategoryVideosUrls[key] = url;
            return url;
          })
        );
        
        setFeaturedListingVideos(tempFeaturedListingVideos);
        setFeaturedListingLogos(tempFeaturedListingLogos);
        setProjectCategoryVideos(tempProjectCategoryVideosUrls);
      };
    
      if (featuredListingInfo.length === 3 && !isLoaded) {
        fetchAllVideos();
        setIsLoaded(true);
      }
      return () => {
        isMounted = false; // Cleanup function to set the flag to false
      };
    }, [featuredListingInfo, isLoaded]);

  const getFeaturedListingInfo = async() =>{
    
    const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
    try {
      const tempFeaturedListingInfo = await Promise.all(
        featuredListings.map(async (listingId) => {
          const response = await fetch(`${API_BASE_URL}/api/getListingInfo`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
            },
            body: JSON.stringify({ listingId: listingId }),
          });
          const result = await response.json();
          if (result.status === 400) {
            
            return null;
          }
          return result;
        })
      );
      setFeaturedListingInfo(tempFeaturedListingInfo.filter(info => info !== null));
    } catch (error) {
      console.log("something went wrong", error);
    }
  }

    const identifyDirectorsReel = (listing) =>{
      const demoReels = listing.demoReels
      let directorReel = null
      demoReels.forEach((reel) => {
        if(reel.category === `Director's Reel`){
          directorReel = reel.fileName

        }
      })
      return directorReel
    }

    const identifyProjectCategoryVideos = (listings) => {
      const tempProjectCategoryVideos = {
        product: null,
        foodAndBeverage: null,
        event: null
      };
      for (const listing of listings) {
        const demoReels = listing.demoReels;
        demoReels.forEach((reel) => {
          if (reel.category === 'Product' && tempProjectCategoryVideos.product === null) {
            tempProjectCategoryVideos.product = reel.fileName;
          } else if (reel.category === 'Food & Beverage' && tempProjectCategoryVideos.foodAndBeverage === null) {
            tempProjectCategoryVideos.foodAndBeverage = reel.fileName;
          } else if (reel.category === 'Event' && tempProjectCategoryVideos.event === null) {
            tempProjectCategoryVideos.event = reel.fileName;
          }
        });
        if (tempProjectCategoryVideos.product != null && tempProjectCategoryVideos.foodAndBeverage != null && tempProjectCategoryVideos.event != null) {
          break;
        }
      }
      return tempProjectCategoryVideos;
    };
    
    // Crossfade image carousel
    useEffect(() => { 
      const interval = setInterval(() => {
        setPreviousImageIndex(currentImageIndex);
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % homePageImages.length);
      }, 3000); // 3 seconds
  
      return () => {clearInterval(interval)};
    }, [currentImageIndex, homePageImages.length]);
  
    // Clear previous image after fade-out animation (1 second)
    useEffect(() => {
      if (previousImageIndex !== null) {
        const timeout = setTimeout(() => {
          setPreviousImageIndex(null);
        }, 1000); // Match this duration with the CSS animation duration
  
        return () => {clearTimeout(timeout)};
      }
    }, [previousImageIndex]);

    const handleSelectCategory = (category) => {
      sessionStorage.setItem('selectedCategory', category);
      window.location.href = '/Directory';
      window.scrollTo(0, 0);
    };
    
  

    const handleSubmit = async () => {
      sessionStorage.setItem('userQuery', userQuery);
      window.location.href = '/Directory';
      window.scrollTo(0, 0);
      };

      const fetchSignedUrl = async (fileName) => {
        const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
        try {
          const response = await fetch(`${API_BASE_URL}/get-signed-url-video`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET, // Secure API secret
            },
            body: JSON.stringify({ filePath: fileName }), // Send data in request body
          });
          const data = await response.json();
            return(data.url);
        } catch (error) {
            console.error("Error fetching signed URL:", error);
        }
    };

    const fetchSignedUrlLogo = async (fileName) => {
      const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";
      
      try {
        const response = await fetch(`${API_BASE_URL}/get-logo-about-image`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET, // Secure API secret
          },
          body: JSON.stringify({ filePath: fileName }), // Send data in request body
        });if (!response.ok) {
              throw new Error('Network response was not ok');
          }
          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
              const data = await response.json();
             
              return data.signedUrl;
          } else {
              const blob = await response.blob();
              const url = URL.createObjectURL(blob);
             
              return url;
          }
      } catch (error) {
          console.error("Error fetching signed URL:", error);
      }
  };
    
    
    return(
        <div>
            <div className="App-body-home" >
            
            <div className="Section-1" >
            
            <div className="homepageImage">
      {/* <div className='crossfade-wrapper'>
        {previousImageIndex !== null && (
          <img
            key={previousImageIndex}
            src={homePageImages[previousImageIndex]}
            alt={`Slide ${previousImageIndex}`}
            className="inactive"
          />
        )}
        <img
          key={currentImageIndex}
          src={homePageImages[currentImageIndex]}
          alt={`Slide ${currentImageIndex}`}
          className="active"
        />
      </div> */}
      <div className='section-1-background'>
        <div className="section-1-colored-embellishment"/>
        <img className='videographer-image' src={man_searching_directory} alt="Man searching the NXTVid Directory on his laptop. A cinema camera is to his right and a camera bag is on the floow to his left."/>
      </div>
    </div>
    <div className="NXTVid-hero-header"><img className='nxtvid-hero-logo' src={nxtvid_logo} alt="NXTVid-logo"/><div>Marketplace</div></div>
        
                <h1 className="Section-1-Header">Spark Ideas. <br /> Discover Demo Reels.  <br/>Hire Video Creators with Confidence.</h1>
                <div className="MainSearchBar">
                    <input className="userQueryInput" type="text" placeholder="What do you want to create?" onChange={(e)=>{setUserQuery(e.target.value)}}/>
                    <div className="searchButton" onClick={handleSubmit}>
                        <img alt="Search Button" className="search-button-icon" src={searchButtonIcon}/>
                    </div>
                    
                </div>
                <div className="under-search-buttons">
                  <div onClick={()=>handleVideographerSignUpButtonClick(userInfo)}>Apply to be a NXTVid Creator</div>
                  <div onClick={handleScrollToHowItWorks}>See how it works ↓</div>
                </div>
                
            </div>
            <div className="Section-2" id="Featured-Video-Specialists">
                <h1 className="Section-Header Section-2-Header">Featured Video Specialists</h1>
                <div className="Featured-Video-Specialists-Container">
                  <div className="Featured-Video-Specialists">
                  
                    {featuredListingInfo.length > 0 ? featuredListingInfo.map((listing, index) => {
                      
                        return(
                          <Card
                          className="Featured-Video-Specialist-Card"
                          backgroundVideoSrc={featuredListingVideos[index]} 
                          size={window.innerWidth > 700 ? 'large' : window.innerWidth > 550 ? 'medium' : "large"}
                          children={<div className="Featured-Video-Specialist" key={index}>
                                      <p className="Featured-Video-Specialist-Name"><img className="Featured-Video-Specialist-Logo" src={featuredListingLogos[index]}/><div className="Featured-Video-Specialist-Company-Name-Container">{listing.companyName}</div></p>
                                      
                                      <Button label={'View Portfolio'} className='View-Portfolio-Button' disabled={false} onClick={()=>window.location.href = (`/Portfolios/${listing.companyUrl}`)}/>
                                  </div>}/>
                            
                        )
                    }) : // map over an empty array of three items to return three loading cards
                    [1, 2, 3].map((_, index) => (
                      <Card
                        className="Featured-Video-Specialist-Card"
                        isLoading={true}
                        size={window.innerWidth > 700 ? 'large' : window.innerWidth > 550 ? 'medium' : "large"}
                        children={<div className="Featured-Video-Specialist" key={index}></div>}/>
                    ))}
                    
                      </div>
                      </div>

              </div>
              <div className="Section-3" id="how-it-works" ref={howItWorksRef}>
              <h1 className="Section-Header Section-3-Header">Great Content in Three Steps</h1>
                <div className="Section-3-Text">
                
                <div className="step">
                  <div className="step-counter">
                    1
                  </div>
                  <div className="step-1-text">
                  <h2>Get Inspired</h2>
                  <p>Type your project idea into our search bar, and let our <strong>AI-driven semantic search</strong> find video clips that match your creative vision. Our system <strong>understands the context</strong> of your requests, delivering results that align with your goals.</p>
                  <p><strong>Discover work from talented creators</strong>, explore their portfolios, and <strong>hire with confidence </strong> using search prompts like:</p>
                <ul>
                  <li>“Find high-energy product ads with athletes.”</li>
                  <br/>
                  <li>“Show me cinematic restaurant promos with warm lighting.”</li>
                  <br/>
                  <li>“I need engaging event recap content for a tech conference.”</li>
                </ul>
                  </div>
                    </div>
                <div className="step">
                <div className="step-counter">
                    2
                  </div>
                  <div className="step-2-text">
                  <h2>Submit an RFP</h2>
                    <p>A <strong>Request for Proposal (RFP)</strong> is your blueprint for a successful video project. Instead of manually drafting complex details, let our <a target="_blank" href="https://chatgpt.com/g/g-X0Aulu9jp-nxtvid-rfp-generator"><strong>AI-driven assistant</strong></a> help you craft a clear, compelling RFP that attracts the right videographers.</p>
                        <p>With <strong>smart suggestions</strong> and <strong>context-aware</strong> guidance, our AI ensures your RFP covers:</p>
                        <ul>
                          <li><strong>Project Goals: </strong>Clearly define your vision (e.g., brand awareness, product launch, event recap).</li>
                          <p></p>
                          <li><strong>Creative Direction: </strong>Describe the style, tone, and key elements you’re looking for.</li>
                          <p></p>
                          <li><strong>Budget & Timeline: </strong>Get structured recommendations to set realistic expectations.</li>
                        </ul>
                  </div>
                    </div>
                <div className="step">
                <div className="step-counter">
                    3
                  </div>
                    <div className="step-3-text">
                    <h2>Accept and Start Pre-Production!</h2>
                    <p>
                    Once your proposal is accepted, it’s time to bring your project to life! Simply <strong>review and sign the agreement, pay the deposit, and kick off production with confidence.</strong>
                    </p>
                    <p>
                    NXTVid’s <strong>AI-powered creative tools</strong> streamline your pre-production process:
                    </p>
                    <ul>
                      <li>
                        <strong><a className="NXTVid-Purple Underlined" target="_blank" href="https://app.nxtvid.io">Storyboard Creator</a>: </strong>Map out your project with AI-assisted scene visualizations.
                      </li>
                      <p></p>
                      <li>
                      <strong><a className="NXTVid-Purple Underlined" target="_blank" href="https://chatgpt.com/g/g-riOc5zEQF-nxtvid-shot-list-generator">Shot List Generator</a>: </strong>Get structured shot recommendations tailored to your project’s style.
                      </li>
                    </ul>
                    </div>
                    </div>
                </div>
                
                
              </div>
              <div className="Section-4" id="Project Categories">
                <h1 className="Section-Header Section-4-Header">Project Categories</h1>
                <div className="Project-Categories-Container">
                    <div className="Project-Categories">
                      {projectCategories.map((category, index) => {
                        return(
                          <Card
                          className="Featured-Video-Specialist-Card"
                          
                          backgroundVideoSrc={category[0] === "Product" ? projectCategoryVideos.product : category[0] === "Food & Beverage" ? projectCategoryVideos.foodAndBeverage : projectCategoryVideos.event} 
                          size={window.innerWidth > 700 ? 'large' : window.innerWidth > 550 ? 'medium' : "large"}
                          children={<div key={index} className="Featured-Video-Specialist">
                                      <p className="Featured-Video-Specialist-Name"><div className="Featured-Video-Specialist-Company-Name-Container">{category[0]}</div></p>
                                      
                                      <Button label={'Get Inspired'} className='View-Portfolio-Button' disabled={false} onClick={()=>{handleSelectCategory(category[0])}}/>
                                  </div>}/>
                            
                        )
                      }
                      )}
                      </div>
                      </div>

              </div>
              <div className="Section-6 " id="AI Section">
                <h1 className="Section-Header Section-6-Header">Video Pre-Production Planning Made Simple </h1>
                <div className="AI-Tools-Container">
                    <div>
                      <Button onClick={()=>window.open('https://chatgpt.com/g/g-X0Aulu9jp-nxtvid-rfp-generator', '_blank')} label='RFP' className='AI-Tool' type='ghost'/>
                    </div>
                      <div>
                        <Button label='' className='Arrow' disabled={true} size='small' icon={arrowImg}/>
                      </div>
                    <div>
                    <Button onClick={()=>window.open('https://chatgpt.com/g/g-lhrsqyBL2-nxtvid-proposal-generator', '_blank')} label='Proposal' className='AI-Tool' type='ghost'/>
                    </div>
                    <div>
                        <Button label='' className='Arrow' disabled={true} size='small' icon={arrowImg}/>
                      </div>
                    <div>
                    <Button onClick={()=>window.open('https://chatgpt.com/g/g-riOc5zEQF-nxtvid-shot-list-generator', '_blank')}  label='Shot List' className='AI-Tool' type='ghost'/>
                    </div>
                    <div>
                        <Button  label='' className='Arrow' disabled={true} size='small' icon={arrowImg}/>
                      </div>
                    <div>
                    <Button onClick={()=>window.open('https://app.nxtvid.io', '_blank')} label='Storyboard' className='AI-Tool' type='ghost'/>
                    </div>
                      </div>

              </div>
              <div className="Section-5" id="who-uses-NXTVid">
              
              <h1 className="Section-Header Section-5-Header">Who Uses NXTVid</h1>
                <div className="Section-5-Text">
                
                <div className="step">
                
                  <div className="step-1-text">
                  <h2>Small to Medium-Sized <br/> Businesses</h2>
                    <p>Marketing directors at small and mid-sized businesses need <strong>high-quality video content</strong> that fits their budget. With <strong>$1,000+ to invest</strong>, they seek professional, polished videos created by experts with <strong>big-brand experience—without the agency price tag.</strong></p>
                    <p>NXTVid’s <strong>streamlined platform and AI-powered tools</strong> connect them with top-tier talent, making it easy to produce exceptional videos that drive growth, enhance engagement, and elevate their brand.</p>
                  </div>
                    </div>
                <div className="step">
                
                  <div className="step-2-text">
                  <h2>Agencies</h2>
                    <p>For agencies managing <strong>large-scale content production for big brands</strong>, NXTVid is a game-changer. Our platform <strong>streamlines complex workflows</strong>, making it easy to <strong>find and hire top-tier talent—locally or worldwide.</strong></p>
                    <p>With <strong>AI-driven tools</strong> like <a className="NXTVid-Purple Underlined" target="_blank" href="https://chatgpt.com/g/g-X0Aulu9jp-nxtvid-rfp-generator">automated RFPs</a>, <a className="NXTVid-Purple Underlined" target="_blank" href="https://chatgpt.com/g/g-riOc5zEQF-nxtvid-shot-list-generator">shot lists</a>, and <a className="NXTVid-Purple Underlined" target="_blank" href="https://app.nxtvid.io">storyboards</a>, agencies can accelerate pre-production, <strong>hitting tight deadlines without compromising creativity.</strong> By reducing time spent on planning and revisions, NXTVid <strong>empowers agencies to focus on what matters most—delivering high-quality content that drives results.</strong></p>
                  </div>
                    </div>
                <div className="step">
                    <div className="step-3-text">
                    <h2>Top-Tier <br/> Video Specialists</h2>
                    <p>Skilled video specialists use NXTVid to <strong>grow their network, hire local talent on the go, and collaborate seamlessly with AI-powered tools.</strong> Whether working from home or on the road, they can showcase their expertise, attract new clients, and streamline every stage of production.</p>
                    <p>With AI-assisted workflows, specialists can <strong>deliver first drafts faster, reduce time spent on planning, and focus on what they do best—creating exceptional content.</strong></p>
                    
                    </div>
                    </div>
                </div>
                
                <div className='Section-5-Image'>
                
                  </div>
              </div>
              
              <div className="Section-7" id="Calling All Video Specialists">
              <h1 className="Section-Header Section-7-Header">Calling All Video Specialists!</h1>
                <div className="Section-7-Text">
                <div className="step">
                  <div className="step-counter">
                    1
                  </div>
                  <div className="step-1-text">
                  <h2>Apply to Join NXTVid</h2>
                    <p>Put your work in front of local businesses and expand your opportunities by joining NXTVid! We’re looking for <strong>skilled videographers with experience on at least three mid-to-large projects</strong>, but we also welcome promising newcomers with a strong portfolio and a passion for high-quality video production.</p>
                  </div>
                    </div>
                <div className="step">
                <div className="step-counter">
                    2
                  </div>
                  <div className="step-2-text">
                  <h2>Build a Strong Profile</h2>
                    <p>Showcase your expertise by adding <strong>reels, testimonials, and behind-the-scenes footage</strong> to your profile. A polished portfolio not only attracts businesses but also increases your visibility—<strong>NXTVid boosts profiles across search engines, social media, ads, and more</strong>, helping you get discovered by the right clients.</p>
                  
                  </div>
                    </div>
                <div className="step">
                <div className="step-counter">
                    3
                  </div>
                    <div className="step-3-text">
                    <h2>Streamline Pre-production!</h2>
                    <p>Use NXTVid’s <strong>AI-powered tools</strong> to draft proposals, generate shot lists, and organize projects effortlessly. <strong>Once a proposal is accepted, you’ll receive a deposit upfront</strong> and can dive straight into pre-production with confidence. <strong>No need to wait—<a className="NXTVid-Purple Underlined" target="_blank" href="https://app.nxtvid.io">start using our tools today</a></strong> to sharpen your pitches and impress clients before your first project even begins.</p>
                    </div>
                    </div>                    
                </div>
                <Button className='Apply-Button' label={'Learn More'} onClick = {()=>{window.location.href = '/MembershipBenefits'}}/>
                
              </div>
            </div>
            <footer>
                <Footer/>
            </footer> 
        </div>
    )
}

export default Home